// src/axios/services/alojamiento.js
import BaseService from "./baseService";

const balnearioService = new BaseService("alojamiento");

export default balnearioService;
